import Component from 'vue-class-component';
import moduleStore from './store/couponList';
import Vue from 'vue';
import PageState from './store/state';
import { toast } from '@/utils/util';
import { getQueryString } from '@/utils/location';
import { judgeDeviceType } from '@/utils/device';
import { Watch } from 'vue-property-decorator';
import moment from 'moment';
/**components**/
@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class couponListPage extends Vue implements IvuePage<PageState> {
  state = new PageState();
  self: Vue = this;
  couponStatus = 1; //券类型 1 可使用 2已使用 3已过期
  isLoading = false;
  finished = false; //当前所有数据是否加载完成
  showRules = false; //是否展示使用规则
  usedImg = require('/public/images/coupons/used-icon.png');
  overtimeImg = require('/public/images/coupons/overtime-icon.png');
  list = [];
  pageIndex = 0;
  pageSize = 4;
  totalPage = 0;
  arrowRight = require('/public/images/coupons/details-icon.png');
  ww_token = getQueryString('ww_token');
  isAPP = judgeDeviceType.isAPP;
  jumpToPayWithCoupon: any = (<any>window).jumpToPayWithCoupon;
  _timer = null;
  @Watch('$route')
  onActiveChange() {
    let { r } = this.$route.query;
    if (r) {
      //刷新页面
      this.getCouponListFn(true);
    }
  }
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  mounted(moduleData: IinjectDatas) {
    document.title = '我的优惠券';
    this.state.self = this;
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  }
  destroyed() {
    console.log('destroyed');
    clearTimeout(this._timer);
    this._timer = null;
  }
  changeType(e) {
    this.pageIndex = 0;
    this.totalPage = null;
    this.list = [];
    this.isLoading = true;
    this.finished = false;
    if (e.target.dataset.idx != undefined) {
      this.couponStatus = e.target.dataset.idx;
    }
    this.onLoadMore();
  }
  onLoadMore() {
    if (this.totalPage != null && this.pageIndex > this.totalPage) {
      this.finished = true;
      this.isLoading = false;
      return;
    }
    this.pageIndex++;
    this.getCouponListFn();
  }
  //展示当前优惠券使用规则
  showCurrRules(idx) {
    let item = this.list[idx];
    item.showRules = !item.showRules;
    this.$set(this.list, idx, item);
  }
  getCouponListFn(isRefresh = false) {
    if(isRefresh){
        this.pageIndex=1;
    }
    let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        couponStatus: this.couponStatus,
      };
    let self = this;
    self.isLoading = true;
    self.$http('getCouponList', params).then(res => {
      self.isLoading = false;
      if (res.code == 200) {
        res.data.results = res.data.results.map(item => {
          item.useThreshold = item.useThreshold && item.useThreshold.split('大于等于')[1];
          return item;
        });
        if (self.pageIndex == 1) {
          self.list = res.data.results;
        } else {
          self.list = self.list.concat(res.data.results);
        }
        this.setCouponTime();
        self.totalPage = res.data.total_pages;
      } else {
        toast(res.message || '获取列表失败，请稍后再试', 'top');
      }
    });
  }
  useCoupon(couponInfo) {
    let mainUseProductType = couponInfo.mainUseProductType;
    //跳转到支付页面
    //根据产品类型跳转到不同的页面
    // - 产品类型=会员：弹窗【会员中心】支付页面，定位到会员价格卡片
    if (mainUseProductType == 1 || mainUseProductType == 0) {
      if (this.isAPP) {
        this.jumpToPayWithCoupon.postMessage(1);
      } else {
        this.$navigateTo({
          url: `/pages/recharge-vip/recharge-vip?fromBtn=couponList&ww_token=${this.ww_token}`,
        });
      }
    }
    //  - 产品类型=声音，跳转到【声音商店】
    if (mainUseProductType == 2) {
      if (this.isAPP) {
        this.jumpToPayWithCoupon.postMessage(2);
      } else {
        this.$navigateTo({
          url: `/pages/voice-shop/voice-shop?ww_token=${this.ww_token}`,
        });
      }
    }
    //  - 产品类型=充电包，定位到【文案字数包】的支付页面
    if (mainUseProductType == 3) {
      if (this.isAPP) {
        this.jumpToPayWithCoupon.postMessage(3);
      } else {
        this.$navigateTo({
          url: `/mine-package/pages/buy-word/buy-word?ww_token=${this.ww_token}&from=couponList`,
        });
      }
    }
  }
  //计算优惠券倒计时
  setCouponTime() {
    clearTimeout(this._timer);
    this._timer = null;
    this.list = this.list.map(val => {
      let endDate = val.endDate + ' 23:59:59';
      let startDate = val.startDate;
      if (endDate) {
        const today = moment();
        const start = moment(startDate);
        const end = moment(endDate);
        const duration = moment.duration(end.diff(today));
        const days = duration.days();
        let hours: any = duration.hours();
        let minutes: any = duration.minutes();
        let seconds: any = duration.seconds();

        if (days < 1 && (hours > 0 || minutes > 0 || seconds > 0)) {
          val.isCountDown = true;
          val.couponStatus = 1;

          if (hours < 10) hours = '0' + hours;
          if (minutes < 10) minutes = '0' + minutes;
          if (seconds < 10) seconds = '0' + seconds;
          val.countStr = `${hours}:${minutes}:${seconds}`;
        } else {
          val.isCountDown = false;
          if (today >= start && days >= 1) {
            //优惠券在可用日期内且有效期大于1天
            val.justEnd = true;
          } else {
            val.justEnd = false;
          }
        }
      }
      return val;
    });

    this._timer = setTimeout(() => {
      this.setCouponTime();
    }, 1000);
  }
}
